import { UploadTypeConfig, UploadTypeConfigCallbackParams } from 'constants/bulkUpload';
import { BulkUploadStagingDetailsSchemaContract } from 'schemas/BulkUploadStagingDetailsSchema';
import { formatBulkPreviewFieldValue } from 'components/EmployeeCustomFields/utils';
import { AccessedFieldDefinition } from 'components/EmployeeCustomFields/types';

type StagingRow = BulkUploadStagingDetailsSchemaContract['bulk_uploads_staging']['data'][0];

/**
 * Preview columns for HRIS custom fields on the employee sheet: one column per
 * definition (settings display order, configured label, typed value formatting
 * — enum labels, Yes/No, ₹, dates). Falls back to a single combined column
 * while definitions are loading or if the fetch failed.
 */
export const getCustomFieldPreviewColumns = (
  data: UploadTypeConfigCallbackParams,
): NonNullable<UploadTypeConfig['preview']['columns']> => {
  if (!data.featureFlags?.hrisCustomFields) {
    return [];
  }

  const definitions = data.customFieldDefinitions ?? [];
  if (definitions.length > 0) {
    return definitions.map((def) => ({
      title: def.label ?? def.fieldKey ?? '',
      render: (item: StagingRow) => {
        const fields = item.file_row?.customFields as Record<string, string> | null | undefined;
        return formatBulkPreviewFieldValue(
          def as AccessedFieldDefinition,
          fields?.[def.fieldKey ?? ''],
        );
      },
    }));
  }

  return [
    {
      title: 'Custom Fields',
      render: (item: StagingRow) => {
        const fields = item.file_row?.customFields as Record<string, string> | null | undefined;
        if (!fields) return '-';
        const nonBlank = Object.entries(fields).filter(
          ([, v]) => v !== '' && v !== null && v !== undefined,
        );
        if (nonBlank.length === 0) return '-';
        return nonBlank.map(([k, v]) => `${k}: ${v}`).join(', ');
      },
    },
  ];
};
